import { Menu } from 'lucide-react';

import Brand from '@/components/common/Brand';

interface MobileHeaderProps {
  onMenuClick: () => void;
}

export function MobileHeader({ onMenuClick }: MobileHeaderProps) {
  return (
    <header className="flex h-16 w-full items-center justify-between bg-surface-card px-5">
      <Brand link="/dashboard" variant="dark" />
      <button
        type="button"
        onClick={onMenuClick}
        className="flex h-10 w-10 items-center justify-center rounded-lg transition-colors hover:bg-surface-primary"
      >
        <Menu className="h-6 w-6 text-foreground-primary" />
      </button>
    </header>
  );
}
